import {abortableAppRequest, delay} from "./utils_request";
import {createElement, removeAllChild, assign, isPlainObject} from "./utils_element";

export default (element, searchOptions = {}) => {

    if (!element || element.nodeType !== 1) {
        throw new Error('The first argument is required and must be an element.');
    }

    let DEFAULT = {
        btnModal: false,
        badgeFilter: true,
        dataTableColumns: {},
        // inputField: null,
        defaultValue: "",
        modal: false,
        urlData: "",
    };

    let options = assign({}, DEFAULT, isPlainObject(searchOptions) && searchOptions),
        inputSearch = element.querySelector('.global-search'),
        filterWrapper = element.querySelector('.filter-wrapper'),
        loader = element.querySelector('.table-loader'),
        table = element.querySelector('table'),
        form = element.querySelector('form'),
        btnOpenForm = element.querySelector('.open-filters'),
        btnApplyForm = element.querySelector('.apply-filters'),
        btnRemoveForm = element.querySelector('.remove-filters'),
        formIsApply = false;

    let init = () => {
        if (options.modal && options.btnModal) {
            options.btnModal.addEventListener('click', function() {
                fetchData();
                $(options.modal).modal('show');
                $(table).DataTable().columns.adjust().draw();
            });
        }

        if (form) {
            buildForm();
        }

        buildDataTable();
        buildDropdown();
        buildInput();

        if (options.badgeFilter) {
            addFilters();
        }
    };

    let buildDataTable = () => {
        $(element.querySelector('table')).DataTable({
            dom: 't',
            pageLength: 100,
            ordering: false,
            columns: options.dataTableColumns,
            language: {
                processing: "Chargement...",
                emptyTable: "Aucune donnée correspondant aux critères",
                paginate: {
                    previous: "Pr&eacute;c&eacute;dent",
                    next: "Suivant",
                },
            },
        });
    };

    let buildDropdown = () => {
        if (btnOpenForm && btnApplyForm) {
            [btnApplyForm, btnRemoveForm].map(e => e.addEventListener('click', () => $(btnOpenForm).dropdown('toggle')));
            $(document).on('click', '.input-group-prepend .dropdown-menu', function (e) {
                e.stopPropagation();
            });
        }
    };

    let buildForm = () => {
        [btnApplyForm, btnRemoveForm].map(e => e.addEventListener('click', () => {
            btnOpenForm.classList.remove(e === btnRemoveForm ? "btn-outline-success" : "btn-outline-gray");
            btnOpenForm.classList.add(e === btnRemoveForm ? "btn-outline-gray" : "btn-outline-success");
            formIsApply = e !== btnRemoveForm;
            fetchData();
        }));
    };

    let buildInput = () => {
        inputSearch.value = options.defaultValue;
        inputSearch.addEventListener('keyup', delay(e => {
            addFilters();
            fetchData();
        }, 500));
    };

    let addFilters = () => {
        if (!options.badgeFilter){
            return ;
        }

        removeAllChild(filterWrapper);
        inputSearch.value.split(' ').map(e => {
            if (e === "") return;
            let badge = createElement('div', 'badge badge-info my-auto mx-2 px-2');
            badge.innerText = e;
            toggleBadge(badge, '', '', 'fad fa-times', enableModelFilter, disableModelFilter);
            filterWrapper.appendChild(badge);
        });
    };

    let disableModelFilter = (badge) => {
        toggleBadge(badge, 'badge-gray', 'badge-info', 'fad fa-plus', disableModelFilter, enableModelFilter);
        fetchData();

    };

    let enableModelFilter = (badge) => {
        toggleBadge(badge, 'badge-info', 'badge-gray', 'fad fa-times', enableModelFilter, disableModelFilter);
        fetchData();
    };

    let toggleBadge = (badge, badgeClassAdd, badgeClassRemove, iconAdd, removeEvent, addEvent) => {
        let btn = createElement('button', 'btn bg-transparent ml-2 text-white p-0 table-badge-btn');

        if (badge.firstElementChild) {
            badge.firstElementChild.remove();
        }

        btn.appendChild(createElement('i', iconAdd));
        btn.removeEventListener('click', removeEvent);
        btn.addEventListener('click', e => addEvent(badge, e));
        badge.appendChild(btn);

        if (badgeClassRemove !== "") {
            badge.classList.remove(badgeClassRemove);
        }

        if (badgeClassAdd !== "") {
            badge.classList.add(badgeClassAdd);
        }

    };

    let fetchData = () => {
        let selectedBadges = filterWrapper.querySelectorAll('.badge-info'),
            selectedBadgesArray = Array.prototype.slice.call(selectedBadges),
            values = [];
        selectedBadgesArray.map(e => values.push(e.innerText));

        if (selectedBadgesArray.length === 0 && options.badgeFilter) {
            return;
        }

        if (!options.badgeFilter) {
            values = inputSearch.value;
        }

        let formData = formIsApply ? $(element.querySelector('form')).serializeArray() : [];

        $(loader).show();
        let request = abortableAppRequest(options.urlData, {'search': values, 'formData': formData});
        request.ready.then(r => {
            $(loader).hide();
            if (r.success !== undefined) {
                $(table).DataTable().clear();
                $(table).DataTable().rows.add(r.success);
                $(table).DataTable().columns.adjust();
                $(table).DataTable().draw();
            }
        });
        addAbortionEvents(request);
    };

    let addAbortionEvents = (request) => {
        inputSearch.addEventListener('keyup', () => request.abort());
        let nodes = document.querySelectorAll('.table-badge-btn');
        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            node.addEventListener('click', () => request.abort());
        }
    };

    init();
    // fetchData();

    return {
        table: table,
        modal: options.modal,
        fetchData: fetchData
    }
}



// WEBPACK FOOTER //
// ./assets/js/search_engine.js